import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogCancel,
} from "./ui/alert-dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Confirm step before an immediate, real Stripe cancellation.
export function CancelSubscriptionDialog({ row, onClose, onCancelled }) {
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/subscriptions/${row.row_id}/cancel`);
      toast.success(`Subscription cancelled for ${row.name}`);
      onCancelled(r.data);
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <AlertDialog open={!!row} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent className="bg-white border-2 border-coral" data-testid="cancel-subscription-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-navy">Cancel subscription?</AlertDialogTitle>
          <AlertDialogDescription data-testid="cancel-subscription-dialog-text">
            <span className="font-semibold text-navy">{row?.name}</span> will stop being billed right away and lose access
            immediately, along with users who only have access to this association. Nothing is deleted, and access returns
            automatically if it subscribes again. No refund is issued for the rest of the month. The association's
            administrators will be emailed.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} className="bg-white text-navy border-navy" data-testid="cancel-subscription-keep-btn">Keep Subscription</AlertDialogCancel>
          <button
            type="button"
            onClick={confirm}
            disabled={busy}
            data-testid="cancel-subscription-confirm-btn"
            className="inline-flex items-center gap-1.5 px-4 py-2 text-[13px] font-semibold text-white rounded-md bg-[#EA6A47] hover:bg-[#B4331A] transition-colors disabled:opacity-50"
          >
            {busy && <Loader2 size={13} className="animate-spin" />}
            Cancel Subscription
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
